import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  internationalReturn: {
    defaultMessage: 'Edit Ship From address to create a domestic return label. International returns are not yet supported.',
    description: 'Error message for international returns',
    id: 'r55Wsn',
  },
  cancelButtonLabel: {
    defaultMessage: 'Cancel Return',
    description: 'Label for button to cancel a pending return',
    id: 'x05r96',
  },
  markAsCompletedButtonLabel: {
    defaultMessage: 'Mark as Completed',
    description: 'Label for button to mark a return as completed (processed)',
    id: 'sjpzgN',
  },
});
